const UPDATES = [
  {
    date: '07-28',
    tag: '更新',
    tagColor: 'bg-primary-100 text-primary-700',
    title: '《剑尊归来》第87话已更新',
    desc: '主角终于觉醒隐藏力量，与最终反派的决战正式打响，本话打斗场面堪称系列最佳。',
  },
  {
    date: '07-28',
    tag: '新番',
    tagColor: 'bg-accent-100 text-accent-700',
    title: '七月新番《星界神话》今日上架',
    desc: '异世界奇幻冒险题材，画风精美剧情紧凑，首话口碑爆炸，编辑部强烈推荐。',
  },
  {
    date: '07-27',
    tag: '完结',
    tagColor: 'bg-secondary-100 text-secondary-700',
    title: '《樱花下的约定》128话暖心完结',
    desc: '两年连载画上完美句号，读者口碑一致好评，全集免费开放阅读中。',
  },
  {
    date: '07-27',
    tag: '活动',
    tagColor: 'bg-accent-100 text-accent-700',
    title: '「暑期追漫季」阅读挑战开启',
    desc: '完成指定阅读任务赢取限定头像框和专属徽章，活动持续到八月底。',
  },
  {
    date: '07-26',
    tag: '更新',
    tagColor: 'bg-primary-100 text-primary-700',
    title: '《我独自升级》第179话同步韩版',
    desc: '韩版更新后两小时内完成翻译上线，刷新本站最快更新记录。',
  },
  {
    date: '07-26',
    tag: '公告',
    tagColor: 'bg-secondary-100 text-secondary-700',
    title: '移动端App 3.2版本正式发布',
    desc: '新增夜间模式优化、离线缓存提速和全新的书架管理功能，体验全面升级。',
  },
  {
    date: '07-25',
    tag: '推荐',
    tagColor: 'bg-accent-100 text-accent-700',
    title: '本周编辑部精选：悬疑推理专题',
    desc: '精选十部高分悬疑漫画，烧脑剧情让你欲罢不能，附编辑部深度测评。',
  },
];

export default function Updates() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-screen-2xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            最新动态
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            漫画更新、新番上架、平台公告一站式掌握
          </p>
        </div>

        <div className="max-w-2xl mx-auto">
          <div className="relative pl-8 md:pl-10 border-l-2 border-background-200 space-y-6">
            {UPDATES.map((item, i) => (
              <div key={i} className="relative">
                <div className="absolute -left-[29px] md:-left-[33px] top-1 w-4 h-4 rounded-full border-2 border-background-200 bg-background-50"></div>
                <div className="flex flex-col sm:flex-row sm:items-start gap-2 sm:gap-4">
                  <div className="flex items-center gap-2 flex-shrink-0">
                    <span className="text-xs text-foreground-400 font-medium whitespace-nowrap">{item.date}</span>
                    <span className={`text-xs px-2 py-0.5 rounded-full font-medium whitespace-nowrap ${item.tagColor}`}>
                      {item.tag}
                    </span>
                  </div>
                  <div className="flex-1">
                    <h3 className="text-sm font-heading font-bold text-foreground-900 mb-1">{item.title}</h3>
                    <p className="text-xs text-foreground-500 leading-relaxed">{item.desc}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}